<template>
  <button
    @click="handleClick"
    class="DifficultyLabel"
    :class="
      selected ? `active color${difficultyTitle}` : `color${difficultyTitle}`
    "
  >
    {{ difficultyTitle }}
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DifficultyLabel",
  props: {
    difficulty: Number,
    sortLabel: Boolean,
  },
  methods: {
    ...mapActions(["updateSortDifficulty"]),
    handleClick() {
      if (!this.sortLabel) return;
      const currentSortDifficulty = this.getSortDifficulty;
      if (currentSortDifficulty.includes(this.difficulty)) {
        const newSortDifficulty = [...currentSortDifficulty].filter(
          (level) => level !== this.difficulty
        );
        this.updateSortDifficulty(newSortDifficulty);
      } else {
        const newSortDifficulty = [...currentSortDifficulty, this.difficulty];
        this.updateSortDifficulty(newSortDifficulty);
      }
    },
  },
  computed: {
    ...mapGetters(["getSortDifficulty"]),
    difficultyTitle() {
      const levels = ["Junior", "Middle", "Senior"];
      return levels[this.difficulty - 1];
    },
    selected() {
      if (!this.sortLabel) return false;
      return this.getSortDifficulty?.includes(this.difficulty);
    },
  },
};
</script>

<style lang="scss" scoped>
.DifficultyLabel {
  padding: 5px 20px;
  margin-right: 10px;
  font-family: $font-primary;
  font-size: 14px;
  background: none;
  color: $color-grey;
  border-radius: 45px;
  cursor: pointer;
}
.colorJunior {
  border: 1px solid #e58aeb;
  &.active {
    color: $color-white;
    background: #e58aeb;
  }
}
.colorMiddle {
  border: 1px solid #4f85ee;
  &.active {
    color: $color-white;
    background: #4f85ee;
  }
}
.colorSenior {
  border: 1px solid #4568dc;
  &.active {
    color: $color-white;
    background: #4568dc;
  }
}

@media screen and (max-width: 650px) {
  .DifficultyLabel {
    display: none;
  }
}
</style>
